export interface MenuItem {
  item: string;
  label: string;
  link: string | null;
  isModal?: boolean;
}

export const itemsMenu: MenuItem[] = [
  {
    label: 'Editar Perfil',
    item: 'profile',
    link: '/user',
  },
  {
    label: 'Alterar senha',
    item: 'password',
    link: '/user/pass',
  },
  {
    label: 'Contratos e Termos de Aceite',
    item: 'contracts',
    link: null,
    isModal: true,
  },
];
